"use client";

import { AppRootLayout } from "@/src/components/layouts";
import { GlobalErrorPage } from "@/src/components/pages";
import { FC } from "react";

interface GlobalErrorProps {
    error: Error & { digest?: string };
    reset: () => void;
}

const GlobalError: FC<GlobalErrorProps> = () => {
    return (
        <AppRootLayout>
            <GlobalErrorPage
                title={"Скоро повернемось!"}
                description={
                    "Ми працюємо над тим, щоб якнайшвидше відновити роботу сайту. Поверніться пізніше — ми вас чекатимемо!"
                }
                image={{
                    src: "/images/global-error.png",
                    alt: "Global error image",
                    width: 200,
                    height: 205,
                }}
            />
        </AppRootLayout>
    );
};

export default GlobalError;
